import { Card, Grid } from "@mui/material";
import React, { FC } from "react";
import Image from "next/image";
import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import styles from "../../styles/pages/careers.module.scss";
import { Job } from "../../interfaces";
import { Department } from "../../services/cms/careers";
import { getIconFromString } from "../../utils/iconMapping";
import { images } from "../../constants";
import Link from "next/link";

const JobCards: FC<Props> = ({ jobs, departmentMap, title, subtitle }) => {
  // departmentMap is only passed by the CMS careers/internship pages. Volunteer
  // (still on the legacy jobPostList node, out of scope for the CMS careers
  // migration) passes none, so it falls back to the original pre-CMS card.
  const isLegacy = departmentMap === undefined;

  return (
    <section>
      <div className="centerContent">
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>

      {jobs.length > 0 ? (
        <Grid container spacing={6} className={styles.jobList}>
          {jobs?.map((job) => {
            if (isLegacy) {
              return (
                <Grid item xs={12} md={6} lg={4} key={"jobpost-" + job.jobTitle}>
                  <Link href={`/career/${job.jobId}`}>
                    <Card variant="outlined" className={styles.jobCard}>
                      <div className={styles.jobImage}>
                        <Image
                          src={job.jobImage || images.dummy}
                          alt={job.jobTitle}
                          width={80}
                          height={80}
                        />
                      </div>

                      <div className={styles.jobContent}>
                        <h3>{job.jobTitle}</h3>
                        <p>
                          <BusinessCenterRoundedIcon
                            className={styles.jobTypeIcon}
                          />{" "}
                          {job.jobType}
                        </p>
                      </div>
                    </Card>
                  </Link>
                </Grid>
              );
            }

            const department = departmentMap[job.departmentId || ""];
            const DeptIcon = getIconFromString(department?.icon);

            return (
              <Grid item xs={12} md={6} lg={4} key={"jobpost-" + job.jobTitle}>
                <Link href={`/career/${job.jobId}`}>
                  <Card variant="outlined" className={styles.jobCard}>
                    <div className={styles.jobContent}>
                      <h3>{job.jobTitle}</h3>
                      {department && (
                        <p>
                          <DeptIcon size={18} className={styles.jobTypeIcon} />{" "}
                          {department.name}
                        </p>
                      )}
                    </div>
                  </Card>
                </Link>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <div className={styles.vacancy}>
          <div className={styles.container}>
            <h3>No Job Vacancies</h3>
            <p>Please check again later for new positions opening soon.</p>
          </div>
        </div>
      )}
    </section>
  );
};

interface Props {
  jobs: Job[];
  // Omitted entirely (not just empty) by pages/volunteer.tsx (still on the
  // legacy jobPostList node, out of scope for the CMS careers migration),
  // which selects the original pre-CMS card with no department chip.
  departmentMap?: Record<string, Department>;
  title: string;
  subtitle?: string;
}

export default JobCards;
